import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import UpdateUser from "../_Login/UpdateUser";


const AccountEdit = () => {

    const {id} = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    let response52 = useInvoke("WebApps", "52", {"@id": id});

    const [account, setAccount] = useState({});

    useEffect(() => {
        
        //Fetch user data
        if (response52.data.payload != undefined) {
            let data = JSON.parse(response52.data.payload).data[0];
            
            setAccount(
                {
                    id: data[0],
                    firstname: data[1],
                    lastname: data[2],
                    email: data[3],
                    mustchangepassword: data[4],
                    role: data[5]
                }
            );
        }

    }, [response52.isPending]);

    //set dropdown list positions
    useEffect(() => {

        if(account["role"]) {
            document.getElementById("role").value = account["role"];
        }

        if(account["mustchangepassword"]) {
            (account["mustchangepassword"] == "True") ? document.getElementById("mustchangepassword").checked = true : document.getElementById("mustchangepassword").checked = false;
        }

    }, [account]);

    const handleFormSubmit = (e) => {

        let obj = {};

        let valid = true;

        //Validate data
        let newPassword = document.getElementById("password").value;
        let confirmPassword = document.getElementById("confirm").value;
        
        if (newPassword.length + confirmPassword.length > 0) {
            if (newPassword != confirmPassword) {
                toast.error('Passwords do not match.');
                valid = false;
            }
            else {
                obj["password"] = newPassword;
            }
        }
        //not changing password
        else {
            obj["password"] = "";
        }

        //first name will not change if no value is provided
        if (document.getElementById("firstname").value != "") {
            obj["firstname"] = document.getElementById("firstname").value;
            
        }
        else {
            obj["firstname"] = document.getElementById("firstname").defaultValue;
        }

        //last name will not change if no value is provided
        if (document.getElementById("lastname").value != "") {
            obj["lastname"] = document.getElementById("lastname").value;
        }
        else {
            obj["lastname"] = document.getElementById("lastname").defaultValue;
        }

        //email will not change if no value is provided
        if (document.getElementById("email").value != "") {
            obj["email"] = document.getElementById("email").value;
        }
        else {
            obj["email"] = document.getElementById("email").defaultValue;
        }

        //role must be selected
        if (document.getElementById("role").value != "") {            
            if (document.getElementById("role").value == "Admin") {
                obj["isAdmin"] = "1";
            }
            else {
                obj["isAdmin"] = "0";
            }
        }
        else {
            valid = false;
            toast.error('No role selected.');
        }

        //must change password?
        obj["mustchangepassword"] = document.getElementById("mustchangepassword").checked;

        if (valid) {
            UpdateUser(
                user["id"], 
                account["id"], 
                obj["password"], 
                user["token"], 
                obj["firstname"], 
                obj["lastname"], 
                obj["email"], 
                obj["isAdmin"], 
                obj["mustchangepassword"]
            )
            .then((response) => {
                if(response == "Update successful.") {
                    toast.success('User updated successfully.');
                    //If modifying self
                    if(user["id"] == account["id"]) {
                        localStorage.clear();
                        setUser({});
                        toast('Please sign in to refresh changes.');
                    }
                    navigate("/Account");
                }
                else {
                    toast.error(`Update Failed.`);
                }
            });
        }
    };

    document.title = "Account - Edit";
    return ( 
        <div className="AccountEdit">
            {user["email"] != undefined && 
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                        <h2>Edit Account - {account["email"]}</h2>

                        <form id="newAccountForm" noValidate="novalidate" autoComplete="off">    

                            <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <input className="form-control" id="email" name="email" defaultValue={account["email"]} type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="firstname">First Name</label>
                                <input className="form-control" id="firstname" name="firstname" defaultValue={account["firstname"]} type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="lastname">Last Name</label>
                                <input className="form-control" id="lastname" name="lastname" defaultValue={account["lastname"]} type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="password">New Password (Leave Blank if not changing)</label>
                                <input className="form-control" id="password" name="password" type="password" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="confirm">Confirm Password (Leave Blank if not changing)</label>
                                <input className="form-control" id="confirm" name="confirm" type="password" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="role">Role</label>
                                <select className="form-control" id="role" name="role">
                                    <option value="">Select Role</option>
                                    <option value="Admin">Admin</option>
                                    <option value="User">User</option>
                                </select>
                            </div>
                            
                            <div className="form-group" style={{marginTop: "32px", marginBottom: "32px"}}>
                                <input className="form-check-input" type="checkbox" id="mustchangepassword" name="mustchangepassword"/>
                                &nbsp;&nbsp;User must change password on next login
                            </div>

                        </form>
                        <Link to="/Account" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>
                    </div>
                </>
            }
        </div>
     );
}
 
export default AccountEdit;